import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
public iduser;
public login;
public nomuser;
public datenaisuser;
public sexe;
public prenomuser;
public passworduser;
public phonenumber;
public emailuser;
public typeuser ;

  constructor() { }
//password
  ngOnInit(): void {
    let user = JSON.parse(localStorage.getItem("user"));
    this.iduser = user.user.id;
    this.login= user.user.username;
    this.nomuser= user.user.nomuser;
    this.prenomuser= user.user.prenomuser;
    this.datenaisuser= user.user.datenaisuser;
    this.sexe= user.user.sexe;
    this.passworduser= user.user.password;
    this.phonenumber= user.user.phonenumber;
    this.emailuser= user.user.email;
    this.typeuser= user.user.typeuser;

  }

}
